<div *ngIf="currentSubscription$ | async as currentSubscription" class="flex flex-col" style="gap: 36px">
  <div>These changes will take effect immediately:</div>
  <div class="icon-list">
    <sbnb-icon icon="details" class="text-smoke-darker"></sbnb-icon>
    <div>
      Your subscription cost will change depending on the number of active properties (where there was at least one
      check-in in the past 30 days).
    </div>
    <div><sbnb-icon icon="sync" class="text-smoke-darker"></sbnb-icon></div>
    <div>Your subscription will renew every month.</div>
    <ng-container *ngIf="currentSubscription?.current_period_end">
      <div><img src="/assets/iconography/date.svg" title="" onload="SVGInject(this)" /></div>

      <div>
        Your next payment will be on
        {{ currentSubscription?.current_period_end | date: 'mediumDate' }}
        .
      </div>
    </ng-container>

    <ng-container *ngIf="newPlan$ | async as newPlan">
      <div><img src="/assets/iconography/log.svg" title="" onload="SVGInject(this)" /></div>
      <div>
        Your expected ongoing monthly cost will be
        {{ newPlan?.base_price?.formatted_string }} and {{ newPlan?.additional_properties?.formatted_string }} for all
        active properties after {{ newPlan.included_properties }}.
      </div>
      <div><img src="/assets/iconography/log.svg" title="" onload="SVGInject(this)" /></div>
      <div *ngIf="newPlan.prorated_price.amount; else estimatedAmount">
        Your next invoice amount is currently prorated at {{ newPlan.prorated_price.formatted_string }} for
        {{ currentSubscription?.active_properties }} active
        {{ 'properties' | pluralize: currentSubscription?.active_properties }}
      </div>
      <ng-template #estimatedAmount>
        <div>
          Your next invoice amount is currently estimated at
          {{ newPlan.estimated_price.formatted_string }} for {{ currentSubscription?.active_properties }} active
          {{ 'properties' | pluralize: currentSubscription?.active_properties }}, which includes any applied promotions
          or credits.

          <div
            *ngIf="
              currentSubscription.discounts?.length || currentSubscription.credits || currentSubscription.taxes?.length
            "
            class="flex flex-col gap-1 text__small mt-2">
            <!-- Discounts -->
            <ng-container *ngIf="currentSubscription.discounts as discounts">
              <div *ngFor="let discount of discounts">
                Includes {{ discount.amount }} discount for {{ discount.description }}
              </div>
            </ng-container>

            <!-- Taxes -->
            <ng-container *ngIf="currentSubscription.taxes as taxes">
              <div *ngFor="let tax of taxes">
                Includes {{ tax.amount }} {{ tax.name }} in {{ currentSubscription.country }}
              </div>
            </ng-container>

            <!-- Credits -->
            <ng-container *ngIf="currentSubscription.credits as credits">
              <div>{{ credits.formatted_string }} of credits will be applied</div>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>
